import { render, staticRenderFns } from "./LinkWrapper.vue?vue&type=template&id=c388ab62&scoped=true"
import script from "./LinkWrapper.vue?vue&type=script&lang=js"
export * from "./LinkWrapper.vue?vue&type=script&lang=js"
import style0 from "./LinkWrapper.vue?vue&type=style&index=0&id=c388ab62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c388ab62",
  null
  
)

export default component.exports